export var getIds = function getIds(id) {
  return id ? {
    root: id,
    label: "".concat(id, "__label"),
    backIcon: "".concat(id, "__back-icon"),
    forwardIcon: "".concat(id, "__forward-icon")
  } : undefined;
};
//# sourceMappingURL=getIds.js.map